import React from "react";
import Typical from "react-typical";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="cols-icon">
              <a href="https://www.facebook.com/usama.muhummad/">
                <i className="fa fa-facebook-square" />
              </a>
              <a href="mailto:usamamuhammad45678@gmail.com">
                <i className="fa fa-google-plus-square" />
              </a>
              <a href="https://www.instagram.com/oxama.m/">
                <i className="fa fa-instagram" />
              </a>
              <a href="https://github.com/usama-mk" target="_blank">
            <i className="fa fa-github" />
          </a>
              <a href="https://twitter.com/OxamaMuhammad">
                <i className="fa fa-twitter" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm <span className="highlighted-text">Usama Muhammad</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Software Engineer 😎",
                    1000,
                    "Full Stack Developer 💻",
                    1000,
                    "MERN Stack Dev 📱",
                    1000,
                    "Cross Platform Dev 🔴",
                    1000
                    
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Knack of building applications with front and back-end operations.
            </span>
          </div>

          <div className="profile-options">
            <button className="btn primary-btn"> Hire Me </button>
            <a href="usama-resume.pdf" download="usama-resume.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
